export enum ColumnDataType {}

export enum NotifyMessageType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warn = 'warn'
}

export enum ScreenType {
  Create,
  Update,
  Detail
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}
